import {Base} from "@/api/Base"

export class SubjectListSummaryListByIdAdv extends Base {
    path = "subjectListSummary/listByIdAdv"
}